import isProd from './isProduction.ts'
import { HEADING, SUBHEADING } from './defaults'

export const endpoints = (prod = isProd()) => ({
  authApiUrl: prod ? 'https://www.easybib.com/api/auth' : 'https://playground.easybib.com/api/auth',
  editorBaseUrl: prod ? 'https://writing.easybib.com' : '//writing-playground.easybib.com',
})

const easybib = ({
  site = 'easybib',
  headingText = HEADING,
  subheadingText = SUBHEADING,
  pasteOnly = false,
  alignText = 'center',
  initRSW = true,
  initFreshToken = true,
} = {}) => {
  const { editorBaseUrl, authApiUrl } = endpoints()

  return {
    headingText,
    subheadingText,
    authApiUrl,
    editorBaseUrl,
    pasteOnly,
    alignText,
    site,
    initFreshToken,
    initRSW,
  }
}

export default easybib
